import { createFileRoute } from "@tanstack/react-router";

import ProductsConsolePage from "@/features/dashboard/pages/products";

export const Route = createFileRoute("/(app)/dashboard/products")({
  component: () => <ProductsConsolePage />,
});
